export const team = {
  addMember: {
    team: 'Team',
    seeHowToUse: 'Se hur man använder',
    help: 'Hjälp',
    addAMember: 'Lägg till medlem',
    addYourTeamMembersText: 'Lägg till dina teammedlemmar som supportagenter för att chatta live med botanvändare.',
    name: 'Namn',
    nameIsRequired: 'Namn krävs',
    email: 'E-post',
    enterAValidEmail: 'Ange en giltig e-postadress',
    password: 'Lösenord',
    passwordMustContain: 'Lösenordet måste innehålla',
    atleast6Characters: 'minst 6 tecken,',
    oneUpperCaseLetter: '1 stor bokstav',
    oneSpecialCharacter: '1 specialtecken*',
    profileIcon: 'Profilikon',
    whatsappNumber: 'WhatsApp-nummer',
    leadVisibility: 'Lead-synlighet*',
    addMember: 'Lägg till medlem',
    role: 'Roll',
    createdOn: 'Skapad den',
    action: 'Åtgärd',
    updateMember: 'Uppdatera medlem',
    add: 'Lägg till',
    cancel: 'Avbryt',
    selectVisibilityOption: 'Välj synlighetsalternativ',
    all: 'Alla',
    assigned: 'Tilldelad',
    nA: 'Ej tillgänglig',
    admin: 'Admin',
    agent: 'Agent',
    placeholders: {
      enterMemberName: 'Ange medlemsnamn',
      enterMemberEmailAddress: 'Ange medlems e-postadress',
      createPasswordForMember: 'Skapa ett lösenord för medlem',
      searchCountry: 'Sök land',
      enterWhatsappNumber: 'Ange WhatsApp-nummer',
      selectLeadsVisibility: 'Välj ledarsynlighet',
      searchTeamByNameOrEmail: 'Sök efter teammedlem efter namn eller e-post',
    },
    modal: {
      deleteTeamMember: 'Radera teammedlem',
      wantToDeleteThisTeamMember: 'Är du säker på att du vill radera denna teammedlem?',
    },
    appTooltip: {
      clickToAddNewTeamMember: 'Klicka för att lägga till en ny teammedlem',
      profileIconOfTeamMember: 'Profilikon/bild av teammedlem',
      nameOfTeamMember: 'Namn på teammedlem',
      emailOfTeamMember: 'E-post för teammedlem',
      whatsappNumberOfTeamMember: 'WhatsApp-nummer för teammedlem',
      roleOfTeamMemberAsAdminOrAgent: 'Roll för teammedlem som admin/agent',
      dateAndTimeOfCreatingTeamMemberRole: 'Datum och tid för att skapa teammedlemsroll',
      editOrDeleteTeamMember: 'Redigera/ta bort teammedlem',
      editTeamMembersDetails: 'Redigera teammedlemsinformation.',
      removeAccessOfTeamMemberByDeletingAccount: 'Ta bort åtkomst för teammedlem genom att radera kontot',
    }
  },
  users: {
    manageMembers: 'Hantera medlemmar',
    managerMembersWhichCanAccessPanel: 'Hantera ditt partnerlag som kan få åtkomst till din panel',
    createNewMember: 'Skapa ny medlem',
    createMember: 'Skapa medlem',
    updateMember: 'Uppdatera medlem',
    deleteTitleMember: 'Radera medlem',
    deleteDescriptionMember: 'Är du säker på att du vill radera denna medlem?',
    noMemberFound: 'Ingen medlem hittad!',
    titleMember: 'Skapa en medlem',
    manageUsers: 'Hantera användare',
    createNewUser: 'Skapa ny användare',
    managerUserWhichCanAccessPanel: 'Hantera din användare som kan få åtkomst till din panel',
    phoneNumber: 'Telefonnummer',
    discard: 'Kassera',
    createUser: 'Skapa användare',
    updateUser: 'Uppdatera användare',
    noUserFOund: 'Ingen användare hittad!',
    title: 'Skapa en användare',
    profileIcon: 'Profilikon*',
    name: 'Namn*',
    email: 'E-post*',
    password: 'Lösenord*',
    selectRole: 'Välj roll*',
    selectARole: 'Välj roll',
    selectLeadVisibility: 'Välj ledssynlighet*',
    confirmPassword: 'Bekräfta lösenord*',
    tableHeadingName: 'Namn',
    tableHeadingEmail: 'E-post',
    tableHeadingPhoneNumber: 'Telefonnummer',
    tableHeadingRole: 'Roll',
    tableHeadingStatus: 'Status',
    tableHeadingAction: 'Åtgärd',
    deleteTitle: 'Radera användare',
    deleteDescription: 'Är du säker på att du vill radera denna användare?',
    placeholders: {
      searchHere: 'Sök här',
      enterName: 'Ange namn',
      enterEmail: 'Ange e-post',
      searchCountry: 'Sök land',
      enterPhoneNumber: 'Ange telefonnummer',
      enterPassword: 'Ange lösenord',
      enterConfirmPassword: 'Ange bekräfta lösenord',
    },
    appTooltip: {
      TOOLTIP_DELETE_USERS: 'Radera användare',
      TOOLTIP_DELETE_MEMBERS: 'Radera medlemmar'
    }
  },
  roles: {
    manageRoles: 'Hantera roller',
    manageYourRoles: 'Hantera dina roller.',
    name: 'Namn*',
    description: 'Beskrivning',
    discard: 'Kassera',
    createRole: 'Skapa roll',
    creteARole: 'Skapa en roll',
    updateRole: 'Uppdatera roll',
    noUserFound: 'Inga användarroller hittade!',
    assignPermissions: 'Tilldela behörigheter*',
    tableHeadingName: 'Namn',
    tableHeadingDescription: 'Beskrivning',
    tableHeadingStatus: 'Status',
    tableHeadingAction: 'Åtgärd',
    module: 'Modul',
    read: 'Läsa',
    write: 'Skriva',
    remove: 'Ta bort',
    notes: 'Anteckningar',
    deleteTitle: 'Radera roll',
    deleteDescription: 'Varning: När du raderar denna roll kommer det också att radera alla användare tilldelade denna roll. \n Är du säker på att du vill radera denna roll?',
    deleteMemberDescription: 'Varning: När du raderar denna roll kommer det också att radera alla medlemmar tilldelade denna roll. \n Är du säker på att du vill radera denna roll?',
    placeholders: {
      enterRoleName: 'Ange rollnamn',
      searchHere: 'Sök här',
      enterDescriptionForRole: 'Ange en beskrivning för rollen'
    },
    appTooltip: {
      TOOLTIP_SECTION_TO_ALLOW_BLOCK: 'Avsnitt du kan tillåta eller blockera användare att komma åt',
      TOOLTIP_CLICK_TO_ADD_ROLE: 'Klicka för att lägga till en ny roll',
    }
  },
  accessControl: {
    users: 'Användare',
    partnerTeam: 'Partnerlag',
    members: 'Medlemmar',
    roles: 'Roller'
  }
};
